import { CategoriaVincolo } from "../categoriaVincolo.model";

export class SopralluogoFase1DTO {
    dataEsecuzione!: Date;
    sopralluogoConEsitoPositivo!: boolean;
    noteSopralluogo!: string;

    necessarieOpereExtra!: boolean;
    preventivoOpereExtra!:number;
    noteOpereExtra!: string;

    necessariaRichiestaPermesso!: boolean;
    noteRichiestaPermesso!: string;
    causaKO!: string;
    categoriaVincolo!: CategoriaVincolo;
  }
  